import axios from 'axios';
import { header } from './header.encry';
async function StoresHelper(props) {
  
     const fetchStores = async () => {
        const response = await axios.get(`${process.env.REACT_APP_PEGASUS_API_URL}/distinctStoreIds`, header());
        return (response.data.response.map(store => ({
            value: store.storeCode,
            label: store.name,
            type: store.store_type,
            fees: store.fees,
            id:store._id
        })));
    };
    const stores = await fetchStores();
    return stores;
}

export default StoresHelper;
